import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/styles';

const alertVariants = cva('flex flex-col relative w-full border [&>svg]:text-current', {
  variants: {
    color: {
      success: 'bg-green-2 border-green-8',
      info: 'bg-blue-2 border-blue-7',
      warning: 'bg-orange-3 border-orange-8',
      error: 'bg-red-2 border-red-8',
      neutral: 'border-border-default',
    },
    size: {
      md: 'rounded-2xl p-4 gap-0.5 [&>svg]:size-5',
      sm: 'rounded-sm p-2 gap-1.5 [&>svg]:size-4',
    },
  },
  defaultVariants: {
    color: 'warning',
    size: 'md',
  },
});

function Alert({ className, color, size, ...props }: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ color, size }), className)} {...props} />;
}

function AlertTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn('flex items-center gap-4 font-heading-l font-semibold text-text-primary', className)}
      {...props}
    />
  );
}

function AlertDescription({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn('text-text-primary font-body-md col-start-2 grid justify-items-start gap-1 pl-9', className)}
      {...props}
    />
  );
}

export { Alert, AlertTitle, AlertDescription };
